const payServerType ="payserver"
const payserverHost ="https://test.atomicgaming.net/pay/sr";
const payUrls={
  order:{
    path:"/order/order",
    method:"POST",
  },
  status:{
    path:(orderId)=>`/order/status/${orderId}`,
    method:"GET",
  },
  wechatPay:{
    path:(orderId)=>`/wechat/do/${orderId}`,
    method:"GET",
  },
  aliPay:{
    path:(orderId)=>`/alipay/do/${orderId}`,
    method:"GET",
  },
  paypal:{
    path:(orderId)=>`/paypal/do/${orderId}`,
    method:"GET",
  },
  payssion:{
    path:(orderId)=>`/payssion/do/${orderId}`,
    method:"GET",
  },

  orderDetail:{
    path:(orderId)=>`/order/${orderId}/detail`,
    method:"GET"
  }
};


export { payServerType,payserverHost,payUrls}
